import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Actions from './Components/Actions'
import Attachment, { confirmDelete } from '@components/Attachment'
import Spinner from '@components/spinner'
import InvoiceDetails from './Components/InvoiceDetails'
import AllocatedFees from './Components/AllocatedFees'
import { StatusLabel } from '@components/StatusLabel'
import InvoiceItems from './Components/InvoiceItems'
import PropTypes from 'prop-types'
import DocumentTitle from 'react-document-title'
import './Invoice.sass'
import { computed, extendObservable } from 'mobx'
import InvoicePayments from './InvoicePayments'
import Comments from '@components/Comments'
import { getFeeItem, formatNumber } from '@atheneum/api/dist/lib'

class Invoice extends Component {
  static propTypes = {
    invoiceStore: PropTypes.object,
    match: PropTypes.object,
    modalStore: PropTypes.object,
    growlStore: PropTypes.object,
    staticData: PropTypes.object,
    contract: PropTypes.object,
    project: PropTypes.object
  }

  componentDidUpdate() {
    const { invoice } = this.props.invoiceStore
    if (invoice) {
      this.props.invoiceStore.getCapiInvoice(invoice.id)
    }
  }
  constructor(props) {
    super(props)
    const { INVOICE_STATUSES, INVOICE_TYPES } = props.staticData.CONST

    extendObservable(this, {
      showAllocatedFees: false,
      isEditingDisabled: computed(() => {
        return (
          props.invoiceStore.invoice &&
          props.invoiceStore.invoice.invoiceStatusId >=
          INVOICE_STATUSES.APPROVED
        )
      }),
      isAllocatingFeesDisabled: computed(() => {
        if (!this.isEditingDisabled) return false

        const { invoice } = this.props.invoiceStore
        const isNonPaygInvoice =
          invoice.invoiceTypeId === INVOICE_TYPES.NON_PAYG
        const isStatusOtherThanCredited =
          invoice.invoiceStatusId !== INVOICE_STATUSES.CREDITED
        if (isNonPaygInvoice && isStatusOtherThanCredited) return false

        return true
      })
    })

    const { getAttachments, get } = props.invoiceStore
    const id = props.match.params.id

    get(id)
    getAttachments(id)
  }

  handleAddInvoiceItem = () => {
    const {
      invoiceStore,
      growlStore,
      staticData,
      project,
      contract
    } = this.props
    const { invoice } = invoiceStore
    const { INVOICE_TYPES, INVOICE_STATUSES } = staticData.CONST

    if (invoice.invoiceStatusId >= INVOICE_STATUSES.APPROVED) {
      return growlStore.showError(
        'Cannot add invoice items to invoices in status Approved or higher.'
      )
    }

    const isPaygInvoice = invoice.invoiceTypeId === INVOICE_TYPES.PAYG

    if (isPaygInvoice) {
      return this.props.modalStore.show({
        type: 'INVOICE_ADD_FEES_FORM',
        props: {
          title: 'Select fees to be allocated ...',
          cancelText: 'Cancel',
          okText: 'Add to invoice',
          invoice: this.props.invoiceStore.invoice,
          project
        }
      })
    } else {
      return this.props.modalStore.show({
        type: 'INVOICE_ITEMS_FORM',
        props: {
          title: 'Add invoice items',
          cancelText: 'Cancel',
          okText: 'Add to invoice',
          invoice: this.props.invoiceStore.invoice,
          contract
        }
      })
    }
  }

  handleAddInvoicePayment = () => {
    const { invoiceStore, modalStore, growlStore, staticData } = this.props
    const { invoice } = invoiceStore
    const { INVOICE_STATUSES } = staticData.CONST

    if (invoice.invoiceStatusId < INVOICE_STATUSES.CREATED) {
      return growlStore.showError(
        'Cannot add payments to invoices in status lower that Created.'
      )
    }

    return modalStore.show({
      type: 'INVOICE_PAYMENT_FORM',
      props: {
        title: 'Add invoice payments',
        cancelText: 'Cancel',
        okText: 'Add payments',
        invoiceStore: this.props.invoiceStore,
        invoice: this.props.invoiceStore.invoice
      }
    })
  }

  handleAddFee = () => {
    return this.props.modalStore.show({
      type: 'INVOICE_ADD_FEES_FORM',
      props: {
        title: 'Add fees',
        cancelText: 'Cancel',
        okText: 'Add to invoice',
        grossAmount: this.props.invoiceStore.invoice.spentGrossAmount,
        invoice: this.props.invoiceStore.invoice
      }
    })
  }

  handleCreateInvoice = () => {
    const { contract, modalStore } = this.props

    return modalStore.show({
      type: 'INVOICE_FORM',
      props: {
        title: 'Draft new invoice',
        cancelText: 'Cancel',
        okText: 'Draft invoice',
        contract
      }
    })
  }

  toggleshowAllocatedFees = () => {
    this.showAllocatedFees = !this.showAllocatedFees
  }

  renderAllocatedFees = () => {
    const { invoiceStore, staticData } = this.props
    const { INVOICE_STATUSES, INVOICE_TYPES } = staticData.CONST
    const { invoice } = invoiceStore

    const isPaygInvoice = invoice.invoiceTypeId === INVOICE_TYPES.PAYG
    if (isPaygInvoice) return null

    const isntCreatedYet = invoice.invoiceStatusId < INVOICE_STATUSES.CREATED
    if (isntCreatedYet) return null

    const feeItem = invoice.fees[0] && getFeeItem(invoice.fees[0])
    const currencyId = feeItem ? feeItem.currencyId : invoice.currencyId
    const currencyName = currencyId
      ? staticData.names.currencies[currencyId]
      : ''
    const spentGrossAmountLabel = invoice.spentGrossAmount
      ? `(${formatNumber(invoice.spentGrossAmount)} ${currencyName})`
      : ''

    const message = this.showAllocatedFees
      ? `Hide allocated fees ${spentGrossAmountLabel}`
      : `Show allocated fees ${spentGrossAmountLabel}`
    const link = (
      <div className='center-text m-b-xxl'>
        <span
          className='show-invoiced-fees-action'
          onClick={this.toggleshowAllocatedFees}
        >
          {message}
        </span>
      </div>
    )

    if (this.showAllocatedFees) {
      return (
        <div className='m-b-xxl'>
          {link}
          <AllocatedFees
            isEditingDisabled={this.isAllocatingFeesDisabled}
            fees={invoice.fees}
            invoice={invoice}
            onAddFees={this.handleAddFee}
          />
        </div>
      )
    } else {
      return link
    }
  }

  renderInvoiceComment(invoice) {
    if (!invoice.comment) return null

    const title = invoice.isCreditNote ? 'Reason for credit note' : 'Comment'
    return (
      <div className='invoice-group'>
        <h2>{title}</h2>
        <p className='text'>{invoice.comment}</p>
      </div>
    )
  }

  render() {
    const { invoiceStore, match, project, contract } = this.props
    const { invoice, invoiceData, loadingSingle } = invoiceStore

    if (loadingSingle) {
      return <Spinner />
    }

    if (!invoice && !invoiceData) {
      return <h2 className='m-t-xl center-text'>Invoice missing.</h2>
    }

    return (
      <DocumentTitle title={`Invoice ${invoiceData.name}| Atheneum Partners`}>
        <div className='invoice-wrapper animate-intro'>
          <Actions
            isEditingDisabled={this.isEditingDisabled}
            invoice={invoice}
            invoiceId={match.params.id}
            projectId={match.params.projectId}
            contractId={match.params.contractId}
          />

          <h2 className='invoice-title'>
            <span className='m-r-md'>{invoice.name}</span>
            <StatusLabel
              statusId={invoice.invoiceStatusId}
              statusesType='invoiceStatuses'
              data-cy='invoice-status-label'
            />{this.props.invoiceStore.isCapiInvoice && <>&nbsp;<div className='status-label'>ENS Invoice</div></>}
            {this.props.invoiceStore.isCapiCallOnlyInvoice && <>&nbsp;<div className='status-label'>ENS API calls only</div></>}
            {this.props.invoiceStore.isFreeCallInvoice && <>&nbsp;<div className='status-label'>ENS Free calls invoice</div></>}
          </h2>

          <div className='invoice-details m-b-xl'>
            <InvoiceDetails project={project} contract={contract} />
          </div>

          <InvoiceItems
            isEditingDisabled={this.isEditingDisabled}
            invoice={invoice}
            onAddInvoiceItems={this.handleAddInvoiceItem}
          />

          {this.renderAllocatedFees()}

          <InvoicePayments
            className='m-t-xl'
            invoice={invoice}
            onAddInvoicePayment={this.handleAddInvoicePayment}
          />

          {this.renderInvoiceComment(invoice)}

          {invoice.internalRemarks && (
            <div className='invoice-group'>
              <h2>Internal remarks</h2>
              <p className='text'>{invoiceData.internalRemarks}</p>
            </div>
          )}

          <div className='invoice-group'>
            <Attachment
              attachments={invoiceStore.attachments}
              tooltip='Placeholder'
              onDelete={fileId =>
                confirmDelete(fileId, invoiceStore.deleteAttachment)
              }
              onOk={() => invoiceStore.getAttachments(invoice.id)}
              url={'/api/invoice/' + invoice.id + '/attachments'}
            />
          </div>
          <div className='invoice-group'>
            <Comments modelId={invoice.id} model='invoice' />
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject(
  'invoiceStore',
  'staticData',
  'modalStore',
  'growlStore'
)(observer(Invoice))
